import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const customerCheckinListRoutes = {
  name: 'list-customer-checkin',
  path: 'customer-checkin-list',
  component: () => import('./CustomerCheckinList.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
